import { useEffect, useState } from "react";
import AdminLayout from "../AdminLayout";
import {
    getOrders as fetchOrders,
    updateOrderStatus as saveOrderStatus,
    deleteOrder as removeOrder,
} from "../../../api/orders";

const STATUSES = ["Pending", "Confirmed", "Shipped", "Delivered", "Cancelled"];

function Orders() {
    const [orders, setOrders] = useState([]);

    const getOrders = async () => {
        try {
            const data = await fetchOrders();

            setOrders(data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getOrders();
    }, []);

    const changeStatus = async (id, status) => {
        // Optimistic: the select shows the new value immediately, and a failed
        // save is undone by the refetch below.
        setOrders((current) =>
            current.map((order) => (order.id === id ? { ...order, status } : order))
        );

        try {
            await saveOrderStatus(id, status);
        } catch (error) {
            console.log(error);

            alert(error.response?.data?.message || "Could not update the order status");
        } finally {
            getOrders();
        }
    };

    const deleteOrder = async (id) => {
        if (!window.confirm("Delete this order?")) return;

        try {
            const data = await removeOrder(id);

            alert(data.message);

            getOrders();
        } catch (error) {
            console.log(error);

            alert(error.response?.data?.message || "Delete Failed");
        }
    };

    return (
        <AdminLayout>
            <div className="mb-6">
                <p className="eyebrow">Fulfilment</p>
                <h2 className="mt-2 font-display text-4xl text-ink">Orders</h2>
            </div>

            <div className="overflow-hidden rounded-2xl border border-sand bg-white shadow-card">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-cream">
                            <tr>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-widest text-muted">
                                    Customer
                                </th>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-widest text-muted">
                                    Phone
                                </th>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-widest text-muted">
                                    Total
                                </th>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-widest text-muted">
                                    Status
                                </th>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-widest text-muted">
                                    Payment
                                </th>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-widest text-muted">
                                    Action
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {orders.length === 0 ? (
                                <tr>
                                    <td
                                        colSpan="6"
                                        className="border-t border-sand/60 px-4 py-8 text-center text-muted"
                                    >
                                        No Orders Found
                                    </td>
                                </tr>
                            ) : (
                                orders.map((order) => (
                                    <tr key={order.id} className="hover:bg-cream/40">
                                        <td className="border-t border-sand/60 px-4 py-3 font-medium text-ink">
                                            {order.customerName}
                                        </td>

                                        <td className="border-t border-sand/60 px-4 py-3 text-muted">
                                            {order.phone}
                                        </td>

                                        <td className="border-t border-sand/60 px-4 py-3 text-maroon">
                                            ₹ {order.totalAmount}
                                        </td>

                                        <td className="border-t border-sand/60 px-4 py-3">
                                            <select
                                                className="field w-40 py-1.5 text-xs"
                                                value={
                                                    STATUSES.includes(order.status)
                                                        ? order.status
                                                        : "Pending"
                                                }
                                                onChange={(e) =>
                                                    changeStatus(order.id, e.target.value)
                                                }
                                            >
                                                {STATUSES.map((status) => (
                                                    <option key={status} value={status}>
                                                        {status}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>

                                        <td className="border-t border-sand/60 px-4 py-3 text-muted">
                                            {order.paymentMethod}
                                        </td>

                                        <td className="border-t border-sand/60 px-4 py-3">
                                            <button
                                                className="rounded-full bg-maroon px-4 py-1.5 text-xs font-medium text-ivory transition-colors hover:bg-maroon-dark"
                                                onClick={() => deleteOrder(order.id)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </AdminLayout>
    );
}

export default Orders;
